export const isKyusyuuHokkaidou = (asset) => {
  if (masterData.pref.byId[asset.pref].shortName === '北海道' ||
      masterData.pref.byId[asset.pref].shortName === '長崎' ||
      masterData.pref.byId[asset.pref].shortName === '佐賀' ||
      masterData.pref.byId[asset.pref].shortName === '福岡' ||
      masterData.pref.byId[asset.pref].shortName === '大分' ||
      masterData.pref.byId[asset.pref].shortName === '熊本' ||
      masterData.pref.byId[asset.pref].shortName === '宮崎' ||
      masterData.pref.byId[asset.pref].shortName === '鹿児島') {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./lib/isKyusyuuHokkaidou.js